import { useAuthStore } from "@/lib/auth";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { mfaMethods } from "../-constant";

const SearchSchema = z.object({
  redirect: z.string().optional(),
  mfa_method: z.nativeEnum(mfaMethods).optional(),
});

export const Route = createFileRoute("/auth/sign-in/")({
  validateSearch: zodValidator(SearchSchema),
  // 認証済みの場合は元の画面にリダイレクト
  beforeLoad: async ({ search }) => {
    const store = useAuthStore.getState();
    const isAuthenticated = await store.isAuthenticated();
    if (isAuthenticated) {
      const targetRedirectTo = search.redirect || "/";
      throw redirect({ to: targetRedirectTo });
    }
  },
});
